import React from "react";
import { LoginScreen } from "../screens/auth/login/Login.screen";
import { Routes, Route, Navigate } from "react-router-dom";
import { LogoutScreen } from "../screens/auth/login/Logout.screen";
import { ChooseUserScreen } from "../screens/auth/login/ChooseUser.screen";
import { ResetPasswordScreen } from "../screens/auth/password/ResetPassword.screen";
import { SetPasswordScreen } from "../screens/auth/password/SetPassword.screen";
import { RequireMfaScreen } from "../screens/auth/mfa/RequireMfa.screen";
import { RecoverMfaScreen } from "../screens/auth/mfa/RecoverMfa.screen";
import { SetupMfaScreen } from "../screens/auth/mfa/SetupMfa.screen";
import { SignupScreen } from "../screens/auth/Signup.screen";
import { CallbackScreen } from "../screens/auth/oauth/Callback.screen";
import { MagicLinkScreen } from "../screens/auth/magic-link/MagicLink.screen";
// import { useApp } from "../hooks/app-context";

//TODO this should be moved to a hook or somewhere more generic
const RouteConfig = {
  login: {
    loginScreen: "/auth/login",
    logoutScreen: "/auth/logout",
    magicLinkScreen: "/auth/magic-link",
    chooseUserScreen: "/auth/choose-user",
    callbackScreen: "/auth/oauth-callback"
  },
  password: {
    resetPasswordScreen: "/auth/reset-password",
    setPasswordScreen: "/auth/set-password/"
  },
  mfa: {
    requireMfaScreen: "/auth/mfa/required",
    recoverMfaScreen: "/auth/mfa/recover",
    setupMfaScreen: "/auth/mfa/setup"
  },
  onboard: {
    onboardingStart: "/onboard",
    onboardUserScreen: "/onboard/user",
    onboardTenantScreen: "/onboard/tenant"
  },
  tenant: {
    signupScreen: "/auth/signup",
    plansScreen: "/tenant/plan"
  },
  user: {
    list: "/user/list"
  }
};

/**
 * This is a combination of all the auth related routes Nblocks has to offer
 * @returns
 */
const AuthRoutes = () => {
  // We need to await this data because otherwise we're eagerly not accepting signup route and navigate away
  // const { tenantSelfSignup } = useApp();

  return /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
    path: "login",
    element: /*#__PURE__*/React.createElement(LoginScreen, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "logout",
    element: /*#__PURE__*/React.createElement(LogoutScreen, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "magic-link",
    element: /*#__PURE__*/React.createElement(MagicLinkScreen, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "reset-password",
    element: /*#__PURE__*/React.createElement(ResetPasswordScreen, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "set-password/:token",
    element: /*#__PURE__*/React.createElement(SetPasswordScreen, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "choose-user",
    element: /*#__PURE__*/React.createElement(ChooseUserScreen, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "oauth-callback",
    element: /*#__PURE__*/React.createElement(CallbackScreen, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "signup",
    element: /*#__PURE__*/React.createElement(SignupScreen, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "mfa"
  }, /*#__PURE__*/React.createElement(Route, {
    path: "required",
    element: /*#__PURE__*/React.createElement(RequireMfaScreen, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "recover",
    element: /*#__PURE__*/React.createElement(RecoverMfaScreen, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "setup",
    element: /*#__PURE__*/React.createElement(SetupMfaScreen, null)
  })), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    element: /*#__PURE__*/React.createElement(Navigate, {
      to: RouteConfig.login.loginScreen,
      replace: true
    })
  }));
};
export { AuthRoutes, RouteConfig };